let bsParams = {     /* 资质情况表 */

	placeSituation:'',     // 场所情况
	otherSituation:'',     // 其他情况
	placePower:'',     // 场所情况所有权（选择项）
	otherPower:'',     // 其他场所所有权
	placeArea:'',     // 场所面积（平方米）
	remark:'',     // 备注

	id:'',     // id
	publishMaterialId:'',     // publishMaterialId
	publishId:'',     // 出版单位ID

}

let paramsRule = {

    placeSituation:[
    	{ required:true, message:'请选择', trigger:'change' },
    ],     // 场所情况
	otherSituation:[
		{ required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 其他情况
	placePower:[
		{ required:true, message:'请选择', trigger:'change' },
	],     // 场所情况所有权（选择项）
	otherPower:[
		 { required:true, message:'不能为空！', trigger:'blur' },
        { max:127, message:'填写内容过长！', trigger:'blur' }
	],     // 其他场所所有权
	placeArea:[
 		 { required:true, message:'请选择', trigger:'blur' },
	],     // 场所面积（平方米）
	remark:[
		  { max:500, message:'填写内容过长！', trigger:'blur' }
	],     // 备注

}

export { bsParams,paramsRule }



// WEBPACK FOOTER //
// ./src/components/LongParams/paramsEt4.js